<div class="error-state-container">
  <div class="error-message">
    We don't have enough sales volume data to generate this Asset Review.
  </div>
  <div class="error-buttons">
    <button class="try-again-btn" (click)="onGoBack()">
       Go Back
    </button>
  </div>
</div>
